import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\CreateImportTaskController::__invoke
* @see app/Http/Controllers/Import/CreateImportTaskController.php
* @route '/api/import/{import}/task'
*/
const CreateImportTaskController = (args: { import: string | number } | [importParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateImportTaskController.url(args, options),
    method: 'post',
})

CreateImportTaskController.definition = {
    methods: ["post"],
    url: '/api/import/{import}/task',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Import\CreateImportTaskController::__invoke
* @see app/Http/Controllers/Import/CreateImportTaskController.php
* @route '/api/import/{import}/task'
*/
CreateImportTaskController.url = (args: { import: string | number } | [importParam: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { import: args }
    }

    if (Array.isArray(args)) {
        args = {
            import: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: args.import,
    }

    return CreateImportTaskController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\CreateImportTaskController::__invoke
* @see app/Http/Controllers/Import/CreateImportTaskController.php
* @route '/api/import/{import}/task'
*/
CreateImportTaskController.post = (args: { import: string | number } | [importParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateImportTaskController.url(args, options),
    method: 'post',
})

export default CreateImportTaskController